import React from "react";
import LegalPage from "@/components/site/LegalPage";

const SECTIONS = [
  {
    id: "what-cookies",
    heading: "What are cookies?",
    body: [
      { type: "p", text: "Cookies are small text files placed on your device when you visit a website. They are widely used to make websites work more efficiently and to provide information to the site's owners. Some cookies are essential to make the site function. Others help us understand how the site is used and improve your experience." },
    ],
  },
  {
    id: "how-we-use",
    heading: "How we use cookies",
    body: [
      { type: "p", text: "We use four categories of cookies on cosecglobal.com, the CoSec App and the CoVerify identity verification service. You can control non-essential cookies through the consent banner you see on your first visit and via the \"Cookies\" link in the footer." },
      { type: "h3", text: "1. Strictly necessary cookies" },
      { type: "p", text: "These cookies are essential for the Services to work. They handle authentication, session security and CSRF protection. They cannot be disabled, without them, you cannot log in or submit forms." },
      { type: "list", items: [
        "cosec_session, keeps you logged in. Lifetime: session.",
        "cosec_csrf, protects against cross-site request forgery. Lifetime: session.",
      ]},
      { type: "h3", text: "2. Functional cookies" },
      { type: "p", text: "These cookies remember your preferences, such as the entity dashboard you last viewed, your language, and your monthly/annual pricing toggle. They make the Services easier to use but are not strictly required." },
      { type: "list", items: [
        "cosec_prefs, stores UI preferences (e.g. pricing toggle, sidebar collapse). Lifetime: 12 months.",
      ]},
      { type: "h3", text: "3. Analytics cookies" },
      { type: "p", text: "These cookies help us understand how visitors interact with the Services so we can improve them. We anonymise the data and never sell it." },
      { type: "list", items: [
        "_ga / _ga_*. Google Analytics 4 cookies. Lifetime: up to 13 months.",
        "cosec_anonymous_id, anonymous product analytics. Lifetime: 12 months.",
      ]},
      { type: "h3", text: "4. Marketing cookies" },
      { type: "p", text: "We do not currently set marketing or advertising cookies. If we do in future, we will update this policy and ask for your consent first." },
    ],
  },
  {
    id: "third-party",
    heading: "Third-party cookies",
    body: [
      { type: "p", text: "Some cookies are set by third-party services we use:" },
      { type: "list", items: [
        "Google Analytics (analytics), see policies.google.com/privacy.",
        "Our identity verification sub-processor (used by the /coverify widget) for biometric and document checks.",
      ]},
    ],
  },
  {
    id: "managing",
    heading: "Managing cookies",
    body: [
      { type: "p", text: "You can manage your consent at any time using the \"Cookies\" link in the footer. You can also delete or block cookies through your browser settings, but blocking strictly necessary cookies will break parts of the Services." },
      { type: "p", text: "Guides for managing cookies in popular browsers: Chrome, Safari, Firefox, Edge, all available in their respective help centres." },
    ],
  },
  {
    id: "changes",
    heading: "Changes to this policy",
    body: [
      { type: "p", text: "We may update this Cookies Policy from time to time. The \"last updated\" date at the top will always reflect the latest version. Material changes will be highlighted in the consent banner." },
    ],
  },
  {
    id: "contact",
    heading: "Contact us",
    body: [
      { type: "p", text: "Questions about cookies? Email privacy@cosecglobal.co or write to CoSec Global Ltd, 20–22 Wenlock Road, London, N1 7GU, United Kingdom." },
    ],
  },
];

export default function CookiesPage() {
  return (
    <LegalPage
      eyebrow="Legal"
      title="Cookies Policy"
      updatedAt="08 March 2026"
      sections={SECTIONS}
      related={[
        { href: "/privacy", label: "Privacy Policy" },
        { href: "/terms", label: "Terms of Service" },
        { href: "/contact", label: "Contact our team" },
      ]}
    />
  );
}
